import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { AbstractControl, FormControl, Validators } from '@angular/forms'
import { MatExpansionPanel } from '@angular/material/expansion'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { Channel, SaveForm, untilDestroy, Destroyable, ActionFailed } from '@tokeet-frontend/tv3-platform'
import { ConnectCtrip, ConnectCtripSuccess } from '@tokeet-frontend/channels'

@Component({
  selector: 'app-connect-trip-wizard-step3',
  templateUrl: './connect-trip-wizard-step3.component.html',
  styleUrls: ['./connect-trip-wizard-step3.component.scss'],
})
export class ConnectTripWizardStep3Component extends Destroyable implements OnInit {
  @ViewChild('settings') startStep: MatExpansionPanel
  @Input() channel: Channel

  @Output() prev = new EventEmitter()
  @Output() connected = new EventEmitter<string>()

  isConnecting = false
  propertyIdCtrl = new FormControl('', [Validators.required])

  constructor(private actions: Actions, private store: Store<any>) {
    super()
  }

  ngOnInit(): void {
    this.actions.pipe(ofType(ConnectCtripSuccess), untilDestroy(this)).subscribe((action) => {
      this.connected.emit()
    })
    this.actions.pipe(ofType(ActionFailed), untilDestroy(this)).subscribe((action) => {
      this.isConnecting = false
    })
  }

  @SaveForm()
  onConnect(form: AbstractControl) {
    const propertyId = this.propertyIdCtrl.value
    this.store.dispatch(ConnectCtrip({ hotelId: propertyId }))
    this.isConnecting = true
  }

  reset() {
    this.propertyIdCtrl.reset()
    this.startStep.open()
  }
}
